import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";
import FragmentSummary from "./fragment-summary";
import PatResultType from "../enums/pat-result-type";
import PatFumbleForcedByPositionPref from "./position-pref/pat-fumble-forced-by-position-pref";

export default class PatFumbled extends Fragment {
    constructor(forcedBy) {
        super();
        this.result = PatResultType.FUMBLED.code;
        this.forcedBy = forcedBy;

        this.requiredData = [
            {
                name: "forcedBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Forced by",
                title: (team) => `Forced By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new PatFumbleForcedByPositionPref(play, this).resolve()
            }
        ];
    }

    getPlayers() {
        return [this.forcedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = `was fumbled, forced by ${stringifier.firstInitial(
            this.forcedBy
        )}`;
        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            forcedBy: playerReducer(this.forcedBy)
        };
    }
}
